@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.banner-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: @space-8;
  color: @settings-page--shipping-fulfilment-banner--text-color;
  background-color: @settings-page--shipping-fulfilment-banner--background-color;
}

.auctane-banner {
  text-align: center;
  &__logo {
    height: 100px;
    vertical-align: middle;
    place-self: center center;
  }
  &__description {
    margin-left: @space-16;
    margin-right: @space-16;
    font-size: 14px;
    line-height: 1.5;
  }
  &__button {
    width: 300px;
    text-align: center;
    margin: @space-16 0;
  }
}

.auctane-link-button {
  width: 300px;
  text-align: center;
  margin: @space-16 0;
}

@media (max-width: 1024px) {
  .auctane-banner {
    &__button {
      width: 80%;
      min-width: 64px;
    }
  }
  .banner-container {
    flex-wrap: wrap;
  }
}
